import React, { useEffect } from "react";
import useTypeDecription from "../../../hooks/useTypeDecription";
import UpiWrapper from "./UpiWrapper";
import { useSelector } from "react-redux";

export default function UpiPage() {
  const lang = useSelector((state) => state.changeLang.language.stepTwo);
  const { content, getContent } = useTypeDecription();

  useEffect(() => {
    getContent("upi");
  }, []);

  return <UpiWrapper>{content}</UpiWrapper>;
}
